import { useCallback, useState } from "react";
import type { SearchRecord } from "./types";
import { searchAll } from "./search";

export function useSearch(defaultModuleRootId?: string) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState<SearchRecord[]>([]);

  const handleSearch = useCallback(async (q: string) => {
    const res = await searchAll(q, 50, defaultModuleRootId);
    setResults(res);
  }, [defaultModuleRootId]);

  return { query, setQuery, results, setResults, handleSearch };
}
